import {IModalService, IModalSettings} from "angular-ui-bootstrap";
import {TextDialog} from "./component/TextInputDialogComponent";
import {Optional} from "../../../js/util/Optional";

export interface DialogParams {
    readonly title?: string;
    readonly value?: string | null;
}

export class TextInputDialog {

    public static id = "textInputDialog";

    /** @ngInject */
    public constructor(private readonly $uibModal: IModalService) {

    }

    public async open(args?: DialogParams): Promise<string> {
        const settings: IModalSettings = {
            size: "sm",
            component: TextDialog,
            resolve: {
                title: () => Optional.of(args).map((a) => a.title).orNull(),
                value: () => Optional.of(args).map((a) => a.value).orNull()
            }
        };
        const instance = this.$uibModal.open(settings);
        return instance.result;
    }
}
